import { render, staticRenderFns } from "./ShareParamsDialog.vue?vue&type=template&id=2242fe1e&scoped=true&"
import script from "./ShareParamsDialog.vue?vue&type=script&lang=js&"
export * from "./ShareParamsDialog.vue?vue&type=script&lang=js&"
import style0 from "./ShareParamsDialog.vue?vue&type=style&index=0&id=2242fe1e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2242fe1e",
  null
  
)

export default component.exports